module.exports = __webpack_public_path__ + "img/tplogo@1x.4ef96b78.png";